import { Button } from 'antd';
import React from 'react';
import { CustomerServiceOutlined } from '@ant-design/icons';
import { AppTopNaviDivider } from '@abb/abb-common-ux-react';

const ITICKET_CREATE_URL =
  'https://iticket.abb.com/#/service-request/application/create?igarid=9AAG031327&organization=CNMOT';

class GetSupport extends React.Component {
  openITicket = () => {
    window.open(ITICKET_CREATE_URL, '_blank', 'noopener,noreferrer');
  };

  render() {
    return (
      <>
        <Button
          icon={<CustomerServiceOutlined />}
          type="text"
          onClick={this.openITicket}
          title="跳转 iTicket 创建工单"
        >
          Get Support
        </Button>
        <AppTopNaviDivider />
      </>
    );
  }
}

export default GetSupport;
